import { render, staticRenderFns } from "./DurationManager.vue?vue&type=template&id=0830d5e0&scoped=true"
import script from "./DurationManager.vue?vue&type=script&lang=ts"
export * from "./DurationManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0830d5e0",
  null
  
)

export default component.exports